
import React from "react";
import CountryFlag from "@/components/country/CountryFlag";

interface VerifiedCountriesDisplayProps {
  verifiedCountries: string[];
}

export function VerifiedCountriesDisplay({
  verifiedCountries,
}: VerifiedCountriesDisplayProps) {
  if (verifiedCountries.length === 0) return null;

  return (
    <div className="mb-4">
      <h3 className="text-sm font-medium mb-2">
        Verified Countries:
      </h3>
      <div className="flex flex-wrap gap-2">
        {verifiedCountries.map((countryCode, index) => (
          <div
            key={index}
            className="flex items-center gap-1 bg-green-50 text-green-700 py-1 px-2 rounded-md border border-green-200"
          >
            <CountryFlag
              countryCode={countryCode}
              className="h-3 w-4"
            />
            <span className="text-sm">{countryCode}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
